export default "__VITE_ASSET__851c1e6a__"